/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const INVOKE_PROCEDURE = gql(`
  mutation InvokeProcedure2(
    $departmentId: ID!
    $procedureId: ID!
    $knowledgeId: ID
    $owner: String
    $name: String
    $description: String
    $debug: Boolean
    $local: Boolean
    $commandParamsInput: CommandParamsInput
    $version: String
    $procedureStage: ProcedureStage
  ) {
    invokeProcedure2(
      departmentId: $departmentId
      procedureId: $procedureId
      knowledgeId: $knowledgeId
      owner: $owner
      name: $name
      description: $description
      debug: $debug
      local: $local
      commandParamsInput: $commandParamsInput
      version: $version
      procedureStage: $procedureStage
    ) {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stateLastUpdatedAt
      attachments
      isArchived
    }
  }
`);

export const CREATE_PROCEDURE = gql`
  mutation CreateProcedure($input: CreateProcedureInput!) {
    createProcedure(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      public
      bookReference
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
      stage
      schedules {
        name
        expression
        enabled
      }
      requests {
        limit
        nextToken
      }
    }
  }
`;

export const UPDATE_PROCEDURE = gql(`
  mutation UpdateProcedure($input: UpdateProcedureInput!) {
    updateProcedure(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      bookReference
      schedules {
        name
        expression
        enabled
      }
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
    }
  }
`);

export const GENERATE_PROCESS_VISUALIZATION = gql`
  mutation GenerateProcessVisualization(
    $procedureId: ID!
    $departmentId: ID!
    $procedureStage: ProcedureStage
  ) {
    generateProcessVisualization(
      procedureId: $procedureId
      departmentId: $departmentId
      procedureStage: $procedureStage
    ) {
      status
      message
    }
  }
`;

export const DELETE_PROCEDURE = gql`
  mutation DeleteProcedure($input: DeleteProcedureInput!) {
    deleteProcedure(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      public
      bookReference
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
      stage
      schedules {
        name
        expression
        enabled
      }
      requests {
        limit
        nextToken
      }
    }
  }
`;

export const UPDATE_PROCEDURE_SCHEDULE = gql`
  mutation UpdateProcedureSchedule($input: UpdateProcedureScheduleInput!) {
    updateProcedureSchedule(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      public
      bookReference
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
      stage
      schedules {
        name
        expression
        enabled
      }
      requests {
        limit
        nextToken
      }
    }
  }
`;

export const CREATE_DRAFT_PROCEDURE = gql`
  mutation CreateProcedureV2($input: CreateProcedureInput!) {
    createProcedureV2(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      public
      bookReference
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
      stage
      schedules {
        name
        expression
        enabled
      }
      requests {
        limit
        nextToken
      }
    }
  }
`;

export const UPDATE_DRAFT_PROCEDURE = gql(`
  mutation updateProcedureV2($input: UpdateProcedureInput!) {
    updateProcedureV2(input: $input) {
      id
      knowledgeId
      departmentId
      text
      name
      owner
      language
      bookReference
      schedules {
        name
        expression
        enabled
      }
      email {
        stage
        email
      }
      title
      version
      assignmentPolicy {
        policyType
        collaborator
      }
    }
  }
`);
